import { useQuery } from "@tanstack/react-query";
import { listChatPrompts } from "@/lib/api";
import { queryKeys } from "@/lib/cache/queryKeys";
import { staleTimes } from "@/lib/cache/staleTimes";
import { useAuth } from "@/lib/auth";

export function useChatPrompts(lang = "ar") {
  const { user } = useAuth();
  const country = user?.operating_country || "JO";

  return useQuery({
    queryKey: queryKeys.chatPrompts(country, lang),
    queryFn: () => listChatPrompts(lang),
    staleTime: staleTimes.chatPrompts,
  });
}
